// src/pages/ProductByCategory.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Parallax } from "react-scroll-parallax";
import { Container } from "react-bootstrap";
import { fadeIn } from "../../Functions/GlobalAnimations";
import ByCategory from "../../Components/Story/ByCategory";

const ProductByCategory = (props) => {
  const [loading, setLoading] = useState(true);

  return (
    <div style={props.style}>

      {/* Liste des produits */}
      <ByCategory loading={loading} setLoading={setLoading} />
    </div>
  );
};

export default ProductByCategory;